import util from '../util'

let controller = 'TipoBloqueioManual'

export default Object.assign({}, util.GetCrud(controller, null),
  {

  })